import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "payment-requests-table-column-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_status = _resolveComponent("bs-status")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status)
      ? (_openBlock(), _createBlock(_component_bs_status, {
          key: 0,
          color: _ctx.getColor()
        }, {
          default: _withCtx(() => [
            (_ctx.status.id === 60)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Оплачен")
                ], 64))
              : (_ctx.status.id === 61)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Отказ от оплаты")
                  ], 64))
                : (_ctx.status.id === 62)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode("Ожидает оплаты")
                    ], 64))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["color"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(" — ")
        ], 64))
  ]))
}